export const getBoardOptionKey = (boardId, columnId, itemId) => {
  return `${boardId}_${columnId}${itemId ? `_${itemId}` : ''}`;
};
